import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { API } from 'aws-amplify';
import { HttpClient } from '@angular/common/http';
import { Observable, from } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApiWrapperService {
  constructor(private readonly http: HttpClient) {}

  get(apiName: string, path: string, options?: any): Observable<any> {
    if (environment.mockAPI) {
      const url = `/api${path}`;
      return this.http.get(url, { params: options?.queryStringParameters });
    }
    return from(API.get(apiName, path, options));
  }

  post(apiName: string, path: string, options: any): Observable<any> {
    if (environment.mockAPI) {
      const url = `/api${path}`;
      return this.http.post(url, options.body);
    }
    return from(API.post(apiName, path, options));
  }

  put(apiName: string, path: string, options: any): Observable<any> {
    if (environment.mockAPI) {
      const url = `/api${path}`;
      return this.http.put(url, options.body);
    }
    return from(API.put(apiName, path, options));
  }

  patch(apiName: string, path: string, options: any): Observable<any> {
    if (environment.mockAPI) {
      const url = `/api${path}`;
      return this.http.patch(url, options.body);
    }
    return from(API.patch(apiName, path, options));
  }
}
